import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import DropdownIndicator from '../common/DropdownIndicator';
import dropdownStyleUtils from '../../dropdownStyleUtils';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
import { isMobile } from '../../screenUtils';
import './ProjectClosure.scss';
var closureReasons = {
  'Project Filled with a Non-Clora resource': ['Internally Sourced', 'Internal Referral', 'Internal Hire (Current Employee)', 'Clora Cost Too High', 'Responsibilities Internally Distributed', 'Recruiting Agency', 'CRO', 'Consulting Agency', 'Unknown'],
  'Project Unfilled': ['Project Scope Change', 'Loss of Budget', 'Unable to Meet Client Requirements', 'Candidate Quality/Culture Fit', 'Unknown'],
  'Unresponsive Client': null,
  'Unqualified Project': null,
  'Unqualified Company': null
};
var ProjectClosure = /*#__PURE__*/function (_Component) {
  function ProjectClosure(props) {
    var _this;
    _classCallCheck(this, ProjectClosure);
    _this = _callSuper(this, ProjectClosure, [props]);
    _this.state = {
      primaryReason: props.primaryReason,
      secondaryReason: props.secondaryReason
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(ProjectClosure, _Component);
  return _createClass(ProjectClosure, [{
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        closeProjectUrl = _this$props.closeProjectUrl,
        resourceId = _this$props.resourceId;
      var _this$state = this.state,
        primaryReason = _this$state.primaryReason,
        secondaryReason = _this$state.secondaryReason;
      putRequest(closeProjectUrl, {
        reason: "".concat(primaryReason).concat(secondaryReason ? ": ".concat(secondaryReason) : ''),
        project: {
          resource_id: resourceId
        }
      }, csrfToken).then(function () {
        window.location.reload();
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(bool) {
      this.setState({
        createInvoice: bool
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        style = _this$props2.style,
        triggerText = _this$props2.triggerText,
        triggerStyle = _this$props2.triggerStyle;
      var _this$state2 = this.state,
        primaryReason = _this$state2.primaryReason,
        secondaryReason = _this$state2.secondaryReason;
      var menuWidth = isMobile() ? '300px' : '400px';
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: triggerText,
        buttonStyles: "btn btn-sm ".concat(style, " ").concat(triggerStyle),
        submitButtonText: "Mark Project Closed",
        cancelButtonText: "Cancel",
        handleSubmit: this.handleSubmit,
        submitDisabled: !primaryReason,
        triggerType: "link",
        idKey: "close-project-modal",
        modalSize: "md"
      }, /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-12"
      }, "Close Project"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-3"
      }, /*#__PURE__*/React.createElement(Select, {
        classNamePrefix: "primary-close-reason",
        options: Object.keys(closureReasons).map(function (r) {
          return {
            value: r,
            label: r
          };
        }),
        placeholder: "Select primary reason",
        value: primaryReason && {
          value: primaryReason,
          label: primaryReason
        },
        onChange: function onChange(opt) {
          return _this2.setState({
            primaryReason: opt.value,
            secondaryReason: null
          });
        },
        styles: _objectSpread({}, dropdownStyleUtils),
        width: menuWidth,
        components: {
          DropdownIndicator: DropdownIndicator,
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        }
      })), primaryReason && closureReasons[primaryReason] && /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, /*#__PURE__*/React.createElement(Select, {
        classNamePrefix: "secondary-close-reason",
        options: closureReasons[primaryReason].map(function (r) {
          return {
            value: r,
            label: r
          };
        }),
        placeholder: "Select secondary reason",
        value: secondaryReason && {
          value: secondaryReason,
          label: secondaryReason
        },
        onChange: function onChange(opt) {
          return _this2.setState({
            secondaryReason: opt.value
          });
        },
        styles: _objectSpread({}, dropdownStyleUtils),
        width: menuWidth,
        components: {
          DropdownIndicator: DropdownIndicator,
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        }
      }))));
    }
  }]);
}(Component);
ProjectClosure.propTypes = {
  style: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  closeProjectUrl: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired,
  triggerText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  triggerStyle: PropTypes.string,
  primaryReason: PropTypes.string,
  secondaryReason: PropTypes.string
};
ProjectClosure.defaultProps = {
  primaryReason: null,
  secondaryReason: null,
  triggerText: 'Closed',
  triggerStyle: '',
  style: ''
};
export default ProjectClosure;